export const baseURL = process.env.REACT_APP_API_URL;

export const endPoints = {
  base: baseURL,
  login: '/login',
  signup: '/signup',
  getUser: '/user',
  resendMobileOtp: '/resend-mobile-otp',
  resendEmailOtp: '/user/resend-email-otp',
  verifyOTP: '/verify/mobile-otp',
  uploadPanImage: '/user/pan-proof-upload',
  submitPanNumber: '/user/pan-number',
  confirmPan: '/user/confirm-pan',
  addEmail: '/user/add-email',
  verifyEmail: '/user/verify-email',
  savePersonalDetails: '/user/personal-details',
  addBankAccount: '/user/add-bank-account',
  setStep: '/user/set-step',
  getStep: '/user/step',
  setPreviousStep: '/user/set-previous',
  userDeclaration: '/user/declaration',
  getAllBanks: '/utils/bank',
  getAllBankBranches: '/utils/bank/details', // + '/BKID?name=BKID0006159',
  reversePennyDrop: '/user/rpd-verification',
  getDigioImageVerifyCredentials: '/user/initiate-workflow/selfie',
  verifyDigioImageVerification: '/user/verify-workflow/selfie',
  getDigioKycCredentials: '/user/initiate-workflow/kyc',
  verifyDigioKyc: '/user/verify-workflow/kyc',
  getAadhaarEsignCredentials: '/user/e-sign-documents',
  verifyAadhaarEsign: '/user/initiate-verification',
  addSign: '/user/add-signature',
  saveNomineeDetails: '/user/add-nominee',
  skipNomineeDetails: '/user/skip-nominee',
  getPincodeDetails: '/utils/pincode', // + '/324005'
  saveIncomeProof: '/user/income-proof',
  verifyIncomeProofSetu: '/user/income-proof',
  personalDetailsModification: "/user/modification/details",
  documentModification: "/user/modification/document",
};

export default {};
